import { useCallback, useState } from 'react';

import { ChannelValues } from 'flow/components/tickets/messageChannels';
import { TicketKey } from 'flow/types/EntityKeys';
import { getReplyChannelForOrigin } from 'flow/utils/ticket-channel-utils';
import { ComposerTab } from './useTicketComposerTab';

// The origin's reply channel, or undefined when it has none. A user's switch only
// holds on the ticket and origin it was made on; derived in render so no stale
// frame shows.
export const useExternalReplyChannel = (
    ticketKey: TicketKey,
    originSubtype?: string,
) => {
    const [picked, setPicked] = useState<{
        ticketKey: TicketKey;
        originSubtype?: string;
        channel: ChannelValues;
    }>();

    const externalChannelSelected: ChannelValues | undefined =
        picked?.ticketKey === ticketKey &&
        picked.originSubtype === originSubtype
            ? picked.channel
            : getReplyChannelForOrigin(originSubtype);

    const setExternalChannelSelected = useCallback(
        (channel: ChannelValues) =>
            setPicked({ ticketKey, originSubtype, channel }),
        [ticketKey, originSubtype],
    );

    return { externalChannelSelected, setExternalChannelSelected };
};

export const getChannelSelected = (
    tabSelected: ComposerTab,
    externalChannelSelected?: ChannelValues,
): 'internal' | ChannelValues =>
    tabSelected === 'reply_external' && externalChannelSelected
        ? externalChannelSelected
        : 'internal';

export const replyChannelSupportsAttachments = (channel?: ChannelValues) =>
    !!channel && channel !== 'sms';
